import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import AccessRequired from './components/AccessRequired';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { canUserUpdateHolidaySettings } from "@shared/utils/AccessControl";
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import IconHeader from '@shared/ui/molecules/IconHeader';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { reset, saveChanges, selectEditCompanyState } from "./edit-company-page/editCompany.duck";
import HolidayLimitsSetting from "./holiday-settings-page/HolidayLimitsSetting";
import HolidayYearSetting from "./holiday-settings-page/HolidayYearSetting";
import HolidayApprovalsSetting from "./holiday-settings-page/HolidayApprovalsSetting";
import { HolidayBookingSetting } from '@shared/ui/organisms/settings/HolidayBookingSetting';
import { Accordian } from '@shared/animations/AnimationVariants';
import { CompanyWideHolidaySetting } from "./components/CompanyWideHolidaySetting";
import {
  HolidayApprovalNotificationSettings
} from '@shared/ui/organisms/settings/HolidayApprovalNotificationSettings';
import {
  NotifyManagerOnLeaveCancellationSetting
} from '@shared/ui/organisms/settings/NotifyManagerOnLeaveCancellationSetting';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function HolidaySettings() {
  const dispatch = useDispatch();
  const current = useSelector(selectCurrentUser);
  const [loading, setLoading] = useState(false);
  const isEditable = useMemo(() => canUserUpdateHolidaySettings(current), [current]);
  const {t} = useTranslation();

  const state = useSelector(selectEditCompanyState);

  useEffect(() => {
    dispatch(reset())
    return () => dispatch(reset());
  }, [dispatch]);

  const done = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 400);
    dispatch(saveChanges());
  };

  return (
    <React.Fragment>
      {loading && <LoadingSpinner fullScreen={true}/>}
      <div className="management">
        <GoBackButton/>
        <IconHeader icon={IconTypes.Holiday} style={{marginBottom: 32}} />
        <HeadlineLarge className="management__title">{t('settings-page.holiday')}</HeadlineLarge>
        <AccessRequired visible={!isEditable} companyAdminsRequired={true} teamAdminsRequired={false}/>

        {isEditable && <>
          <CompanyWideHolidaySetting />

          <HolidayBookingSetting />

          {current?.companyEntity.enableHolidayBooking && <>
            <Accordian isOpen={!!current?.companyEntity.enableHolidayBooking} className="">
              <HolidayYearSetting disabled={!isEditable} onEnableChange={() => {}} />
              <HolidayLimitsSetting disabled={!isEditable} />
              <HolidayApprovalsSetting disabled={!isEditable} />
              <HolidayApprovalNotificationSettings />
              <NotifyManagerOnLeaveCancellationSetting />
            </Accordian>
          </>}

          {isEditable ?
            <PrimaryButton disabled={!state.dirty} size={ButtonSize.Large} fullWidth={true} text="button.save-changes" click={() => done()}/> : null}
        </>}

      </div>
    </React.Fragment>
  );
}
